import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const superAdminDashboard = createAsyncThunk(
  "superAdminDashboard/fetch",
  async (data, { rejectWithValue, serializeError }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/esignLogPerDays`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const superAdminDashboardSlice = createSlice({
  name: "superAdminDashboard",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {
    clearCreditData: (state) => {
      state.data = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminDashboard.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(superAdminDashboard.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(superAdminDashboard.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});
export const { clearCreditData } = superAdminDashboardSlice.actions;
export default superAdminDashboardSlice.reducer;
